import type { Theme } from '@mui/material/styles';

import {
  ICON_BUTTON_SPACING_LARGE_MULTIPLIER,
  ICON_BUTTON_SPACING_MEDIUM_MULTIPLIER,
  ICON_BUTTON_SPACING_SMALL_MULTIPLIER,
} from '@themes/constants';

export default function IconButton(theme: Theme) {
  return {
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
        },
        sizeMedium: {
          fontSize: '1rem',
          width: theme.spacing(ICON_BUTTON_SPACING_MEDIUM_MULTIPLIER),
          height: theme.spacing(ICON_BUTTON_SPACING_MEDIUM_MULTIPLIER),
        },
        sizeLarge: {
          fontSize: '1.25rem',
          width: theme.spacing(ICON_BUTTON_SPACING_LARGE_MULTIPLIER),
          height: theme.spacing(ICON_BUTTON_SPACING_LARGE_MULTIPLIER),
        },
        sizeSmall: {
          fontSize: '0.75rem',
          width: theme.spacing(ICON_BUTTON_SPACING_SMALL_MULTIPLIER),
          height: theme.spacing(ICON_BUTTON_SPACING_SMALL_MULTIPLIER),
        },
      },
    },
  };
}
